import React from "react";
import moment from "moment";

/**
 * Format address name by capitalizing words
 */
export function formatAddressName(address) {
  function capitalizeFirstLetter(word) {
    if ((word && word.length < 5) || (word && word.includes("#"))) {
      return word;
    } else {
      word = word.toLowerCase();
      const firstLetter = word.charAt(0);
      const firstLetterCap = firstLetter.toUpperCase();
      const remainingLetters = word.slice(1);
      const capitalizedWord = firstLetterCap + remainingLetters;
      return capitalizedWord;
    }
  }

  if (!address) return "";
  const split = address.split(" ");
  const mappedSplit = split.map((name) => {
    const isAllUpperCase = name === name.toUpperCase();
    if (isAllUpperCase) {
      return capitalizeFirstLetter(name);
    }
    return name;
  });
  return mappedSplit.join(" ");
}

/**
 * Format date as JSX with month, day, year in separate divs
 */
export function getMonthAndYearString(inputTime) {
  try {
    if (!inputTime || inputTime === "-") return "-";
    if (!moment(inputTime).isValid()) return "-";
    const month = moment(inputTime).format("MMM");
    const day = moment(inputTime).format("D");
    const year = moment(inputTime).format("YY");
    return (
      <div className="date-td">
        <div>{month}</div>
        <div>{day},</div>
        <div>{year}</div>
      </div>
    );
  } catch (err) {
    return "-";
  }
}

/**
 * Calculate price per square foot
 */
export function calculatePricePerSqft(calculation, saleP, sqft) {
  if (calculation === "-") {
    const res = Math.round(saleP / sqft);
    return res.toLocaleString();
  } else {
    return Math.round(calculation).toLocaleString();
  }
}
